<!-- BFF Responsive Header -->
<header class="bff-header">
  <nav class="bff-navbar bff-navbar--light bff-navbar--mb">
    <div class="bff-header__container">

      <!-- Left: Desktop = Retour, Mobile = Menu hamburger -->
      <div class="bff-header__side bff-header__side--left">
        <button type="button" class="bff-button bff-button--secondary bff-button--icon-only bff-show-mobile" 
          (click)="openSidebarEvent.emit()" aria-label="Menu">
          <i class="fa-solid fa-bars"></i>
        </button>
        <a (click)="goToOldInterface()" class="bff-link bff-hide-mobile">
          <button type="button" class="bff-button bff-button--primary">
            <i class="fa fa-share-square fa-rotate-180"></i>
          </button>
        </a>
      </div>

      <!-- Center: Logo - Desktop: full logo, Mobile: full logo centered (same size as profile) -->
      <div class="bff-header__center">
        <a href="https://www.budgetfacile.com" target="_blank" class="bff-link" aria-label="Budgetfacile">
          <img src="/assets/images/bf-logo.png" alt="bf-logo" class="bff-logo bff-logo--header" />
        </a>
      </div>

      <!-- Right: User Badge + Profile -->
      <div class="bff-header__side bff-header__side--right">
        <!-- User Badge - hidden on mobile to avoid overlap with logo -->
        <div class="bff-badge-container bff-header-badges bff-header-badges--hide-mobile">
          <!-- Premium Discovery first (most specific) -->
          <div *ngIf="isPremiumDiscoveryUser" 
               class="bff-premium-badge bff-version-badge-clickable" 
               (click)="openSubscriptionInfo()"
               title="Cliquez pour gérer votre abonnement">
            <i class="fas fa-user"></i>
            <span>PREMIUM DÉCOUVERTE</span>
          </div>
          <!-- Premium Gifted second -->
          <div *ngIf="isPremiumGiftedUser && !isPremiumDiscoveryUser" 
               class="bff-premium-badge bff-version-badge-clickable" 
               (click)="openSubscriptionInfo()"
               title="Cliquez pour gérer votre abonnement">
            <i class="fas fa-user"></i>
            <span>PREMIUM OFFERT</span>
          </div>
          <!-- Regular Premium last (only if not Discovery or Gifted) -->
          <div *ngIf="isPremiumUser && !isPremiumGiftedUser && !isPremiumDiscoveryUser" 
               class="bff-premium-badge bff-version-badge-clickable" 
               (click)="openSubscriptionInfo()"
               title="Cliquez pour gérer votre abonnement">
            <i class="fas fa-user"></i>
            <span>PREMIUM</span>
          </div>

          <div *ngIf="isProGiftedUser"
               class="bff-pro-badge bff-version-badge-clickable"
               (click)="openSubscriptionInfo()"
               title="Cliquez pour gérer votre abonnement">
            <i class="fas fa-user"></i>
            PRO OFFERT
          </div>

          <div *ngIf="isProUser && !isProGiftedUser"
               class="bff-pro-badge bff-version-badge-clickable"
               (click)="openSubscriptionInfo()"
               title="Cliquez pour gérer votre abonnement">
            <i class="fas fa-user"></i>
            PRO
          </div>

          <div *ngIf="isEssentielGiftedUser"
               class="bff-essentiel-badge bff-version-badge-clickable"
               (click)="openSubscriptionInfo()"
               title="Cliquez pour gérer votre abonnement">
            <i class="fas fa-user"></i>
            ESSENTIEL OFFERT
          </div>

          <div *ngIf="isEssentielUser && !isEssentielGiftedUser"
               class="bff-essentiel-badge bff-version-badge-clickable"
               (click)="openSubscriptionInfo()"
               title="Cliquez pour gérer votre abonnement">
            <i class="fas fa-user"></i>
            ESSENTIEL
          </div>

          <div *ngIf="isStandardAutoImportUser" 
               class="bff-standard-badge bff-version-badge-clickable" 
               (click)="openSubscriptionInfo()"
               title="Cliquez pour gérer votre abonnement">
            <i class="fas fa-user"></i>
            STANDARD AUTO-IMPORT
          </div>

          <div *ngIf="isStandardUser && !isStandardAutoImportUser && !isEssentielUser && !isProUser" 
               class="bff-standard-badge bff-version-badge-clickable" 
               (click)="openSubscriptionInfo()"
               title="Cliquez pour gérer votre abonnement">
            <i class="fas fa-user"></i>
            STANDARD
          </div>
        </div>

        <div ngbDropdown class="d-inline-block bff-header-dropdown" #profileDropdown="ngbDropdown">
          <button
            type="button"
            class="bff-button bff-button--orange bff-button--icon-only"
            id="profileMenu"
            ngbDropdownToggle
            aria-expanded="false"
            aria-label="Menu profil"
          >
            <i class="fa-solid fa-user" aria-hidden="true"></i>
          </button>
          <div ngbDropdownMenu aria-labelledby="profileMenu" class="bff-profile-menu">
            <!-- Badge visible uniquement sur mobile (masqué sur desktop où il est dans la barre) -->
            <div class="bff-profile-menu__badge bff-hide-desktop" (click)="profileDropdown.close(); openSubscriptionInfo()">
              <div *ngIf="isPremiumDiscoveryUser" class="bff-premium-badge bff-version-badge-clickable">
                <i class="fas fa-user"></i><span>PREMIUM DÉCOUVERTE</span>
              </div>
              <div *ngIf="isPremiumGiftedUser && !isPremiumDiscoveryUser" class="bff-premium-badge bff-version-badge-clickable">
                <i class="fas fa-user"></i><span>PREMIUM OFFERT</span>
              </div>
              <div *ngIf="isPremiumUser && !isPremiumGiftedUser && !isPremiumDiscoveryUser" class="bff-premium-badge bff-version-badge-clickable">
                <i class="fas fa-user"></i><span>PREMIUM</span>
              </div>
              <div *ngIf="isProGiftedUser" class="bff-pro-badge bff-version-badge-clickable">
                <i class="fas fa-user"></i> PRO OFFERT
              </div>
              <div *ngIf="isProUser && !isProGiftedUser" class="bff-pro-badge bff-version-badge-clickable">
                <i class="fas fa-user"></i> PRO
              </div>
              <div *ngIf="isEssentielGiftedUser" class="bff-essentiel-badge bff-version-badge-clickable">
                <i class="fas fa-user"></i> ESSENTIEL OFFERT
              </div>
              <div *ngIf="isEssentielUser && !isEssentielGiftedUser" class="bff-essentiel-badge bff-version-badge-clickable">
                <i class="fas fa-user"></i> ESSENTIEL
              </div>
              <div *ngIf="isStandardAutoImportUser" class="bff-standard-badge bff-version-badge-clickable">
                <i class="fas fa-user"></i><span>STANDARD AUTO-IMPORT</span>
              </div>
              <div *ngIf="isStandardUser && !isStandardAutoImportUser && !isEssentielUser && !isProUser" class="bff-standard-badge bff-version-badge-clickable">
                <i class="fas fa-user"></i><span>STANDARD</span>
              </div>
            </div>
            <hr class="dropdown-divider bff-hide-desktop">
            <button type="button" ngbDropdownItem (click)="profileDropdown.close(); logout()">
              <i class="fas fa-sign-out-alt me-2"></i>{{ 'topmenu.logout' | translate }}
            </button>
          </div>
        </div> 
      </div>
    </div>
  </nav>
</header>